import { Theme } from '@mui/material';

export const styles = (theme: Theme, onDarkBackground = false) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.custom.gap.xSmall,
    flexShrink: 0,
    fontFamily: 'Inter, sans-serif',
  },
  text: {
    fontSize: theme.typography.textSize['0_875'],
    color: onDarkBackground ? '#aeb8c8' : '#64748b',
    fontWeight: theme.typography.fontWeight.normal,
    whiteSpace: 'nowrap',
  },
  logo: {
    height: '1rem',
    width: 'auto',
    opacity: onDarkBackground ? 0.95 : 0.7,
  },
});
